// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error label[data-v-12e9a00c]{color:#4d4d4d}.sub-borrower-section[data-v-12e9a00c]{border:1px solid #d8d8d8;background:#ededed;padding:10px;margin-bottom:10px}select[data-v-12e9a00c]{margin:0 0 1rem}.error select[data-v-12e9a00c]{margin-bottom:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
